<template>
  <div class="main">
    <div class="title">
      <div class="name" v-if="Number(stateNum) === 2">已拒绝专家基本信息</div>
      <div class="name" v-else>专家基本信息</div>
      <div class="btn" @click="back">
        <img src="../../../assets/images/back.png" alt="">
        返回
      </div>
    </div>
    <div class="form-box">
      <div class="detail-box" v-if="Number(stateNum) === 2">
        <p>拒绝原因：{{state_remark}}</p>
        <span>申请时间：{{create_time}}</span>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="专家照片">
              <div class="img-box">
                <el-upload
                    ref="upload"
                    class="avatar-uploader"
                    accept="image/png,image/gif,image/jpg"
                    :action="fileUpUrl"
                    :show-file-list="false"
                    :on-error="uploadError"
                    :on-success="uploadSuccess"
                    :before-upload="beforeAvatarUpload">
                  <img v-if=" ruleForm.img != ''" :src="urlStr + ruleForm.img" alt="">
                  <img v-else src="../../../assets/images/moren.png" alt="">
                </el-upload>
                <span class="moren" @click="ruleForm.img = ''">设为默认头像</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别">
              <el-select v-model="ruleForm.sex" placeholder="请选择性别" style="width: 100%;">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="领域" prop="lingyu">
              <el-select v-model="ruleForm.lingyu" placeholder="请选择" style="width: 100%;">
                <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="政治面貌">
              <el-input v-model="ruleForm.mianmao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="出生日期">
              <el-date-picker
                  v-model="ruleForm.date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学历">
              <el-input v-model="ruleForm.xueli"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="民族">
              <el-input v-model="ruleForm.minzu"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通讯地址">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="身份证号">
              <el-input v-model="ruleForm.idcard"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作单位">
              <el-input v-model="ruleForm.danwei"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="手机号">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职称">
              <el-input v-model="ruleForm.zhicheng"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属行业">
              <el-input v-model="ruleForm.hangye"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-for="(domain,index) in ruleForm.zhiwu"  :key="domain.key">
            <el-form-item
                label="职务"
               >
              <div class="flex justify-start align-center">
                <el-input v-model="domain.value"></el-input>
                <el-button class="add" v-if="index === 0" @click="addDomain">添加</el-button>
                <el-button class="add" v-else @click.prevent="removeDomain(domain)">删除</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="简介" prop="content">
              <ck-decoupled-editor ref="editor" :content="ruleForm.content"></ck-decoupled-editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="ruleForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <div class="flex justify-between">
            <span class="btn1" @click="submitForm('ruleForm')">修改保存</span>
            <div class="flex justify-end" v-if="Number(act) === 1">
              <span class="btn2" @click="handleExamine">拒绝</span>
              <span class="btn3" @click="examine(1,'')">通过</span>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import CkDecoupledEditor from "@/components/CKDecoupledEditor";
import {expertDetail, examine, getExpertType, edit} from "@/api/index";
import {fileUpUrl, urlStr} from '@/config/index'
export default {
  name: "examine-detail",
  data() {
    return {
      id:'',
      fileUpUrl: fileUpUrl,
      urlStr: urlStr,
      requestData: {type: 2},//1图片2文件
      ruleForm: {
        img: '',
        name:'',
        sex:'',
        lingyu:'',
        mianmao:'',
        date:'',
        xueli:'',
        minzu:'',
        address:'',
        idcard:'',
        danwei:'',
        phone:'',
        zhicheng:'',
        hangye:'',
        zhiwu: [{
          value: ''
        }],
        content:'',
        remark:''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
         ],
        lingyu: [
          { required: true, message: '请输入领域', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入简介', trigger: 'change' },
        ],
      },
      options:[],
      create_time:'',
      state_remark:'',
      stateNum: 0,
      act:''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {CkDecoupledEditor},
  created() {
    this.id = this.$route.query.id
    this.act = this.$route.query.act
    this.$emit("setActive", {
      active: 1,
      act: this.act,
      name: `专家管理 > ${this.act == 1 ? '专家审核' : '专家信息'} > 详情`
    })

    this.getExpertType()
    this.expertDetail()
  },
  methods: {
    // 专家详情
    async expertDetail(){
      let _res = await expertDetail(
          this.user.mid,
          this.id
      );
      if (_res.status === 200) {
        this.ruleForm = {
          img: _res.data.pic,
          name: _res.data.name,
          sex: String(_res.data.sex),
          lingyu: _res.data.type_id,
          mianmao: _res.data.political_status,
          date: _res.data.birthday,
          xueli: _res.data.educational_background,
          minzu: _res.data.nationality,
          address: _res.data.mailing_address,
          idcard: _res.data.id_number,
          danwei: _res.data.company,
          phone: _res.data.phone_number,
          zhicheng: _res.data.professional_title,
          hangye: _res.data.industry,
          zhiwu: JSON.parse(_res.data.job),
          content: _res.data.desc,
          remark: _res.data.remark
        }
        this.state_remark =  _res.data.state_remark
        this.create_time =  _res.data.create_time
        this.stateNum =  _res.data.state
      } else {
        this.$message.error(_res.msg)
      }
    },

    submitForm(formName) {
      let _info = this.$refs.editor.getInfo()
      this.ruleForm.content = _info.content
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sub()
        } else {
          this.$message.error('请填写完整..');
          return false;
        }
      });
    },

    // 获取分类
    async getExpertType(){
      let _res = await getExpertType(
          this.user.mid
      );
      if(_res.status === 200){
        this.options = _res.data
      }else {
        this.$message.error(_res.msg);
      }
    },

    // 提交信息
    async sub(){
      let _res = await edit(
          this.user.mid,
          this.id,
          this.ruleForm.img,
          this.ruleForm.name,
          this.ruleForm.sex,
          this.ruleForm.lingyu,
          this.ruleForm.mianmao,
          this.ruleForm.date,
          this.ruleForm.xueli,
          this.ruleForm.minzu,
          this.ruleForm.address,
          this.ruleForm.idcard,
          this.ruleForm.danwei,
          this.ruleForm.phone,
          this.ruleForm.zhicheng,
          this.ruleForm.hangye,
          JSON.stringify(this.ruleForm.zhiwu),
          this.ruleForm.content,
          this.ruleForm.remark,
      );
      if(_res.status === 200){
        this.$message.success(_res.msg);
      }else {
        this.$message.error(_res.msg);
      }
    },

    // 审核拒绝
    handleExamine(){
        this.$prompt('请输入拒绝原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^.+$/,
          type: 'warning',
          confirmButtonClass: 'btn-class',
          inputErrorMessage: '请输入拒绝原因'
        }).then(({ value }) => {
          this.examine(2,value)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
    },

    // 专家审核
    async examine(state,state_remark) {
      let _res = await examine(
          this.user.mid,
          this.id,state,state_remark
      );
      if(_res.status === 200){
        this.$message.success(_res.msg);
      }else {
        this.$message.error(_res.msg);
      }
    },

    back(){
      this.$router.push({
        path:`${Number(this.act) === 1 ? '/home/examine' : '/home/detail'}`,
      })
    },

    removeDomain(item) {
      var index = this.ruleForm.zhiwu.indexOf(item)
      if (index !== -1) {
        this.ruleForm.zhiwu.splice(index, 1)
      }
    },

    addDomain() {
      this.ruleForm.zhiwu.push({
        value: '',
        key: Date.now()
      });
    },

    //  上传成功
    uploadSuccess(response) {
      this.uping.close();
      if (response.status === 200) {
        this.ruleForm.img = response.data.url
      } else {
        this.$message.success(response.msg)
      }
    },

    //  上传失败
    uploadError() {
      this.uping.close();
      this.$message({
        message: "上传出错，请重试！",
        type: "error",
        center: true,
      });
    },

    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }

      this.uping = this.$loading({
        lock: true,
        text: "上传中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
      });
    },

  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.add {
  width: 70px;
  height: 40px;
  border: 1px solid #dcdfe6;
  color: #606266;
  font-size: 14px;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
  border-radius: 4px;
  margin-left: 5px;
  padding: 0;
}
.btn1 {
  width: 120px;
  height: 40px;
  background-color: #0a2240;
  border-radius: 20px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.btn2 {
  width: 120px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 20px;
  border: solid 1px #0a2240;
  font-size: 14px;
  color: #0a2240;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
  margin-right: 20px;
}
.btn3 {
  width: 120px;
  height: 40px;
  background-color: #ff9600;
  border-radius: 20px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.img-box {
  width: 125px;
  max-height: 164px;
  border-radius: 10px;
  border: 1px solid #0a2240;
  position: relative;
  //overflow: hidden;
  margin-bottom: 20px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: scale-down;
  }
  .upload-demo {
    width: 100%;
    height: 100%;
  }
  .moren {
    display: block;
    line-height: 30px;
    font-size: 12px;
    background-color: #0a2240;
    color: #ffffff;
    width: 125px;
    text-align: center;
    border-radius: 3px;
    position: absolute;
    bottom: -36px;
    right: 0;
    z-index: 300;
    cursor: pointer;
  }
}
.main {
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
    .btn {
      width: 100px;
      height: 40px;
      background-color: #ffffff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      letter-spacing: 1px;
      color: #0a2240;
      cursor: pointer;
      img {
        width: 14px;
        height: 12px;
        margin-right: 2px;
      }
    }
  }
  .form-box {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px 12px;
    flex: 1;
    .detail-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 20px;
      p {
        width: 601px;
        padding: 14px;
        background-color: #dae0e6;
        border-radius: 10px;
        border: solid 1px #dae0e6;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
      }
      span {
        font-size: 14px;
        color: #333333;
      }
    }
  }
}
</style>


